<style>
.my-autocomplete {
  li {
    line-height: normal;
    padding: 7px;

    .name {
      text-overflow: ellipsis;
      overflow: hidden;
    }
    .addr {
      font-size: 12px;
      color: red;
    }
  }
}

</style>

<template>

<el-autocomplete style="display: block;" custom-item="my-item-zh" popper-class="my-autocomplete" v-model="value" :fetch-suggestions="querySearchAsync" :placeholder="placeholder" @select="handleSelect">
</el-autocomplete>

</template>

<script>

import BusinessModel from '@/framework/models/businessModel'
import Vue from 'vue'

Vue.component('my-item-zh', {
  functional: true,
  render: function (h, ctx) {
    var item = ctx.props.item
    return h('li', ctx.data, [
      h('div', { attrs: { class: 'name' } }, [item.name]),
      h('span', { attrs: { class: 'addr', style: 'color: #b4b4b4;;' } }, [item.value])
    ])
  },
  props: {
    item: { type: Object, required: true }
  }
})

export default {
  name: 'search-address-input',
  data: function () {
    let data = {
      value: null,
      options4: []
    }
    return data
  },
  watch: {
    defaultValue: function (value) {
      this.value = value
    },
    value: function (value) {
      this.$emit('input', value)
    }
  },
  props: {
    defaultValue: {
      type: String,
      default: function () {
        return ''
      }
    },
    mapType: {
      type: String,
      default: function () {
        return null
      }
    },
    placeholder: {
      type: String,
      default: function () {
        return '请输入位置、如小区、办公楼'
      }
    }
  },
  methods: {
    handleSelect: function (item) {
      this.$emit('onChenged', item)
    },
    querySearchAsync: function (keyword, cb) {
      if (!keyword) {
        cb([])
        return
      }

      let _this = this
      let listener = {
        onResponse: function (response) {
          let data = null
          if (typeof response.data === 'string') {
            data = JSON.parse(response.body)
          } else {
            data = response.body
          }

          let newResults = []
          let result = data.pois
          for (var i = 0, length = result.length; i < length; i++) {
            let item = result[i]
            newResults.push({
              name: item.name,
              value: item.pname + ' ' + item.cityname + ' ' + item.adname + ' ' + item.address,
              location: item.location,
              province: item.pname,
              city: item.cityname,
              county: item.adname
            })
          }
          cb(newResults)
        }
      }

      let params = {
        'keyword': encodeURIComponent(keyword)
      }

      if (this.mapType) {
        this.params.type = this.mapType
      }

      BusinessModel.findAMapLocations(this, params, listener)
    },
    setText: function (address) {
      this.value = address
    }
  }
}

</script>
